/* Custom nav styles */
import './nav/epicGamesNavWrapper.sass';
/* Custom footer styles */
import './footer/footer.sass';
import './error/error.sass';
import './home/heroBlock.sass';
import './home/videoBlock.sass';
import './home/aboutBlock.sass';
import './home/socialBlock.sass';
import './home/discussBlock.sass';
/* New Home Styles */
import './homeV2/headerBlock.sass';
import './homeV2/communityBlock.sass';
import './homeV2/aboutBlock.sass';
import './homeV2/aboutCarousel.sass';
import './homeV2/socialLink.sass';
import './overlay/videoOverlay.sass';
import './homeV2/newsBlock.sass';
import './homeV2/newsItem.sass';
import './homeV2/CTASection.sass';
/* FAQ Styles */
import './faq/faqSection.sass';
import './faq/qaSection.sass';
import './faq/quickLink.sass';
/*Load Screen Styles */
import './loadScreen/LoadScreen.sass';
/*TextVideo component*/
import './landing/VideoText.sass';
import './landing/DownloadNowHeaderBlock.sass';
